import styled from 'styled-components'

import { helpers } from 'styles'

export const Title = styled.h2`
	color: ${helpers.color.textHeader};
	font-weight: 600;
	margin: 0 0 2px;
	font-size: ${helpers.font.size.base};
`
